import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

console.warn('[MobileTopBanner] hello i comming — main.ts loaded (DOM banner, no Angular component)');

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    console.warn('[MobileTopBanner] hello i comming — Angular bootstrap complete');
  })
  .catch((err) => console.error(err));
